import React, { useEffect } from 'react';
import { SEO } from '../components/SEO';

const Facilitator: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO 
        title="Facilitator Standards | Monday Night Group"
        description="Standards and guidelines for Monday Night Group facilitators."
      />

      {/* Hero Section */}
      <section 
        className="relative h-[50vh] bg-gradient-to-r from-blue-900 to-blue-700 flex items-center"
        style={{ 
          backgroundImage: 'url(/images/about/image.png)', 
          backgroundSize: 'cover',
          backgroundPosition: 'top'
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="container mx-auto px-4 z-10">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-4">
              Facilitator Standards
            </h1>
            <p className="text-xl text-white">
              Guidelines for leading and fostering meaningful discussions
            </p>
          </div>
        </div>
      </section>

      <section className="py-12 md:py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <img
              src="/facilitator-standards.jpg"
              alt="Facilitator Standards - Eight standards including active time in the Word, consistent exhibiting of the Fruits of the Spirit, observe the Ten Commandments, commit to purity, be set apart, speak life, stewardship, and discipleship"
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Facilitator;